import { render } from "./ScoreCards.vue?vue&type=template&id=c6bf9240"
import script from "./ScoreCards.vue?vue&type=script&lang=js"
export * from "./ScoreCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__